import PropTypes from "prop-types";
import classNames from "classnames";
import { useState } from "react";
import SinglePageAppLink from "../../../../components/SinglePageAppLink";
import styles from "./GuidedSearchSingleTile.css";

export const GuidedSearchSingleTile = ({
  selectionKey,
  name,
  imageUrl,
  linkUrl,
  isSelected,
  onSelect,
}) => {
  const [hasImageError, setHasImageError] = useState(false);

  return (
    <li
      className={styles.tile}
      data-guided-search-selected={isSelected ? "true" : "false"}
    >
      <SinglePageAppLink
        href={linkUrl}
        className={classNames(styles.link, {
          [styles.linkSelected]: isSelected,
        })}
        onClick={() => onSelect(selectionKey)}
      >
        <div
          className={styles.imageWrapper}
          data-testid="guided-search-single-image-wrapper"
        >
          {!hasImageError && (
            <img
              src={imageUrl}
              alt={name}
              className={styles.image}
              loading="lazy"
              onError={() => setHasImageError(true)}
            />
          )}
        </div>
        <p
          className={classNames(styles.name, {
            [styles.nameSelected]: isSelected,
          })}
        >
          {name}
        </p>
      </SinglePageAppLink>
    </li>
  );
};

GuidedSearchSingleTile.propTypes = {
  selectionKey: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
    .isRequired,
  name: PropTypes.string.isRequired,
  imageUrl: PropTypes.string.isRequired,
  linkUrl: PropTypes.string.isRequired,
  isSelected: PropTypes.bool,
  onSelect: PropTypes.func.isRequired,
};

export default GuidedSearchSingleTile;
